import PairIcon from './PairIcon'

export default (Vue) => {
  Vue.component('PairIcon', PairIcon)
}



// WEBPACK FOOTER //
// ./src/icons/index.js